import { useRecoilValue } from 'recoil';

import { livePreviewVisibleState } from './livePreviewEvents';

const useLivePreviewToggle = () => useRecoilValue(livePreviewVisibleState);

export default useLivePreviewToggle;
